export default __webpack_public_path__ + "static/security-privacy-851b9aeaeb4e6a16647be54de2e3ab63.webp";